import React from "react";
import styled from "styled-components";
import { AdBanner, AD_SLOT_TYPE__TOP } from '@insiderintelligence/googleadmanager';


const OuterContainer = styled.div`
  iframe {
    margin: 0 auto;
  }
`;

interface TopAdProps {
  addMarginTop?: boolean;
}

export const TopAd = ({ addMarginTop = true }: TopAdProps): JSX.Element => {
  const baseClasses = "w-auto min-h-top-banner lg:min-h-top-banner-desktop mb-0 mx-auto";
  const marginClasses = addMarginTop ? "lg:mt-20 -mt-3" : "";
  
  return (
    <OuterContainer className={`${baseClasses} ${marginClasses}`}>
      <AdBanner adSlotType={AD_SLOT_TYPE__TOP} />
    </OuterContainer>
  );
};
